import { Scene, WebGLRenderer, PerspectiveCamera, Color, BoxGeometry, MeshBasicMaterial, Mesh } from 'three';
var OrbitControls = require('three-orbitcontrols');
/**
 * RendererState state
 *
 * @export
 * @class RendererState
 */
var rendArr = [];
for (var i = 0; i < 0; i++) {
    var renderer = new WebGLRenderer({ antialias: true, alpha: true });
    rendArr.push(renderer);
}
var StateScene = new Scene();
StateScene.background = new Color('yellow');
var geometry = new BoxGeometry(1, 1, 1);
var material = new MeshBasicMaterial({ color: 0x00ff00 });
var cube = new Mesh(geometry, material);
StateScene.add(cube);
StateScene.name = 'STATE SCENE';
var StateCamera = new PerspectiveCamera(35, 1000 / 800, 0.1, 10);
StateCamera.position.set(2, 4, 7);
var controls = new OrbitControls(StateCamera);
StateScene.add(controls);
var RendererState = /** @class */ (function () {
    function RendererState() {
        this.renderer = rendArr;
        // loaded: Boolean = false
        this.StateScene = StateScene;
        this.StateCamera = StateCamera;
    }
    return RendererState;
}());
export { RendererState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/renderers/rendererState.ts
// module id = 583
// module chunks = 50